import { type FC } from 'react';

// MUI
import Typography from '@mui/material/Typography';
import { NORMAL_FONT_SIZE } from '../utils';

interface PdfFormNoteProps {
  content?: string;
  sx?: React.CSSProperties;
}

const PdfFormNote: FC<PdfFormNoteProps> = ({ content, sx }) => {
  const defaultContent =
    '(Các món rau xào, rau canh có thể thay đổi theo mùa hoặc do điều kiện thời tiết khách quan)';

  return (
    <Typography
      sx={{
        fontWeight: 600,
        textAlign: 'center',
        fontSize: NORMAL_FONT_SIZE,
        fontStyle: 'italic',
        ...sx,
      }}
    >
      {content ? content : defaultContent}
    </Typography>
  );
};

export default PdfFormNote;
